import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DEFAULT_UOM,
  SYSTEMS_OF_MEASURE
} from '../../../constants/uom';
import {
  formatRadon,
  formatTemperature,
  formatPressure,
  formatHumidity
} from '../../../utils/formatters';

import Table from '../../shared/Table';


export class TestResultsTable extends React.Component {
  render() {
    return (
      <Table
        headers={this.headers}
        rows={this.rows}
      />
    );
  }

  get headers() {
    const {
      unitOfMeasure,
      showRadon,
      showAlpha,
      showTemperature,
      showHumidity,
      showPressure
    } = this.props;
    const units = SYSTEMS_OF_MEASURE[unitOfMeasure];

    const dataColumns = [
      showRadon && `Radon (${units.radon})`,
      showAlpha && 'Alpha Count',
      showTemperature && `Temperature (${units.temperature})`,
      showHumidity && `Humidity (${units.humidity})`,
      showPressure && `Pressure (${units.pressure})`
    ].filter(column => !!column);

    return [
      'Hour',
      ...dataColumns,
      ''
    ];
  }

  getEvents(tamper, battery, ac) {
    return [
      <If
        condition={tamper}
        key={tamper}
      >
        <i className='fa fa-asterisk' title='Tamper' />
      </If>,
      <If
        condition={battery}
        key={battery}
      >
        <i className='fa fa-battery-empty ml-2' title='Battery' />
      </If>,
      <If
        condition={ac}
        key={ac}
      >
        <i className='fa fa-plug ml-2' title='A/C Power' />
      </If>,
    ];
  }

  get rows() {
    const {
      results=[],
      showRadon,
      showAlpha,
      showTemperature,
      showHumidity,
      showPressure,
      unitOfMeasure
    } = this.props;
    return results.map(({
      hour,
      radon,
      alpha,
      temp,
      humidity,
      pressure,
      tamper,
      battery,
      ac
    }) => {
      const data = [
        showRadon && formatRadon(radon, unitOfMeasure),
        showAlpha && alpha,
        showTemperature && formatTemperature(temp),
        showHumidity && formatHumidity(humidity),
        showPressure && formatPressure(pressure)
      ].filter(value => value !== false);

      return [
        hour,
        ...data,
        this.getEvents(tamper, battery, ac)
      ];
    });
  }
}

TestResultsTable.propTypes = {
  results: PropTypes.array,
  unitOfMeasure: PropTypes.string,
  showRadon: PropTypes.bool,
  showAlpha: PropTypes.bool,
  showTemperature: PropTypes.bool,
  showHumidity: PropTypes.bool,
  showPressure: PropTypes.bool
};

TestResultsTable.defaultProps = {
  results: [],
  unitOfMeasure: DEFAULT_UOM,
  showRadon: true,
  showAlpha: true,
  showTemperature: true,
  showHumidity: true,
  showPressure: true
};

const mapStateToProps = ({profile}) => ({
  unitOfMeasure: profile.uom
});

export default connect(mapStateToProps)(TestResultsTable);


// WEBPACK FOOTER //
// src/components/testDetails/TestResultsTable/index.jsx